import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { Link } from 'react-resource-router';
import { trackSectionHeaderClick } from 'analytics/commonAnalytics';
import { MOBILE } from '../../../constants/breakpoints';

const MainPanelSectionHeader = ({
  title,
  subtitle,
  link,
  linkText,
  viewAllAnalyticsName,
  testId,
}: {
  title: string;
  subtitle?: React.ReactElement;
  link?: string;
  linkText?: string;
  viewAllAnalyticsName?: string;
  testId?: string;
}) => {
  const onClickViewAll = () => {
    // TODO find implementation of this component and add the proper registry data portal link with the correct actionSubjectId
    trackSectionHeaderClick(viewAllAnalyticsName ?? 'sectionHeader', true);
  };

  return (
    <div css={headerContainerStyles} data-testid={testId}>
      <div css={rowStyles}>
        <h3 css={titleStyles}>{title}</h3>
        {link && linkText && (
          <div css={linkContainerStyles}>
            <div css={linkStyles}>
              <span css={cursorStyles}>
                <Link to={link} onClick={onClickViewAll}>{`View all`}</Link>
              </span>
            </div>
          </div>
        )}
      </div>
      {subtitle && <div css={[rowStyles, subtitleStyles]}>{subtitle}</div>}
    </div>
  );
};

const headerContainerStyles = css({
  width: '100%',
});

const cursorStyles = css({ cursor: 'pointer' });

const titleStyles = css({
  fontSize: token('space.400'), //32px
  fontWeight: token('font.weight.semibold'),
  fontFamily: token('font.family.brand.heading'),
  lineHeight: token('space.500'), //40px

  [`@media (max-width: ${MOBILE.MAX_WIDTH}px)`]: {
    fontSize: '24px',
    lineHeight: '32px',
  },
});

const linkContainerStyles = css({
  display: 'flex',
  height: token('space.500'),
  padding: `${token('space.100')} ${token('space.150')}`,
  justifyContent: 'center',
  alignItems: 'center',
});

const linkStyles = css({
  color: token('color.text.brand'),
  textAlign: 'center',
  fontFamily: token('font.family.brand.body'),
  fontSize: '16px',
  fontWeight: token('font.weight.semibold'),
  lineHeight: '20px',
});

const rowStyles = css({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const subtitleStyles = css({
  color: token('color.text'),
  /* Web/Body/Desktop/Regular */
  fontFamily: 'Inter',
  fontSize: token('space.200'),
  fontStyle: 'normal',
  fontWeight: token('font.weight.regular'),
  lineHeight: token('space.300'),
});

export default MainPanelSectionHeader;
